import { render, staticRenderFns } from "./blankScriptDistribution_.vue?vue&type=template&id=4f4df230&"
import script from "./blankScriptDistribution_.vue?vue&type=script&lang=js&"
export * from "./blankScriptDistribution_.vue?vue&type=script&lang=js&"
import style0 from "./blankScriptDistribution_.vue?vue&type=style&index=0&id=4f4df230&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports